module.exports = __webpack_public_path__ + "static/media/baoan.fdd1fae.mp3";


//////////////////
// WEBPACK FOOTER
// ./static/img/baoan.mp3
// module id = ls3j
// module chunks = 1